import { Component, OnInit } from '@angular/core';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { RfqService, QuotesService, RFQ } from '@app/core/quotes';
import { Quotation } from '@app/core/quotes/store/quotes.model';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { environment } from '@app/env-service';

import { NegotiatePriceFormComponent } from '../negotiate-price-form/negotiate-price-form.component';
import { QuotationPopupFormComponent } from '../quotation-popup-form/quotation-popup-form.component';
import { QuotationVariantFormComponent } from '../quotation-variant-form/quotation-variant-form.component';
import { RfqClientProfileComponent } from '../rfq-client-profile/rfq-client-profile.component';
import { RfqDetailsComponent } from '../rfq-details/rfq-details.component';
import { RfqQuotationVariantsComponent } from '../rfq-quotation-variants/rfq-quotation-variants.component';

@Component({
  selector: 'cnc-rfq-quotations',
  templateUrl: './rfq-quotations.component.html',
  styleUrls: ['./rfq-quotations.component.scss'],
})
export class RfqQuotationsComponent implements OnInit {
  length = 0;
  pageSize = 20;
  pageSizeOptions :number[] = [5, 10, 25, 100];
  noImgUrl :string = 'no-image-available.png';
  url :string = environment.url;
  rfq :RFQ;

  constructor(
    public rfqService :RfqService,
    public quotesService :QuotesService,
    private route :ActivatedRoute,
    private modalSvc :NgbModal,
    private toastr :ToastrService,
    public settingsSvc :SettingsService,
    private translate :TranslateService,
  ) {}

  ngOnInit() {
    this.quotesService.init();
    this.route.params.subscribe((params) => {
      this.rfqService.setActiveById(params.id, true);
      this.quotesService.refreshList();
    });
    this.rfqService.activeRecord$.subscribe((rfq) => {
      this.rfq = rfq;
    });
  }

  getRecords(event :PageEvent) {
    const params = {
      page: event.pageIndex + 1,
      per_page: event.pageSize,
    };
    this.quotesService.setParams(params);
    this.quotesService.refreshList();
  }

  negotiatePrice(quotation :Quotation) {
    const modalRef = this.modalSvc.open(NegotiatePriceFormComponent, {});
    modalRef.componentInstance.quotation = quotation;
  }

  viewClientInfo() {
    // this.rfqService.setActive(rfq, true);
    const modalRef = this.modalSvc.open(RfqClientProfileComponent, {});
    modalRef.componentInstance.rfq = this.rfq;
  }

  showDetails() {
    const modalRef = this.modalSvc.open(RfqDetailsComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.showActions = false;
  }

  showQuotationForm(quotation ?:any) {
    const modalRef = this.modalSvc.open(QuotationPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.quotation = JSON.parse(JSON.stringify(quotation));
    modalRef.componentInstance.rfq = this.rfq;
  }

  addQuotation() {
    const modalRef = this.modalSvc.open(QuotationPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.rfq = this.rfq;
  }

  newVariantQuote(quotation :Quotation) {
    const modalRef = this.modalSvc.open(QuotationVariantFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.rfq = this.rfq;
    modalRef.componentInstance.quotation = quotation;
  }

  viewVariantQuotes(quotation :Quotation) {
    const modalRef = this.modalSvc.open(RfqQuotationVariantsComponent, {
      size: 'lg',
      windowClass: 'xl1280',
    });
    // modalRef.componentInstance.rfq = rfq;
    modalRef.componentInstance.quotation = quotation;
  }

  delete(quotation :Quotation) {
    Swal.fire({
      title: this.translate.instant('MESSAGES.CONFIRM_DELETE_QUOTE', {
        country: quotation.country,
      }),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.quotesService.delete(quotation.id).subscribe((resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.DELETE_SUCCESS.TEXT'),
            this.translate.instant('MESSAGES.DELETE_SUCCESS.TITLE'),
          );
        });
      }
    });
  }
}
